export default "__VITE_ASSET__MksD49I8__"